import React from 'react';
import { getImageAssetPath } from '@/lib/imageHelper';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

interface GalleryProps {
  /**
   * Die ID des Referenzprojekts (für Aria-Label)
   */
  projectId: string;
  
  /**
   * Der Name des Referenzprojekts (für Aria-Label)
   */
  projectName: string;
  
  /**
   * Array von Bild-Dateinamen
   */
  images: string[];
  
  /**
   * Fallback-Logo, falls keine Bilder vorhanden sind
   */
  logoFallback: string;
}

const Gallery: React.FC<GalleryProps> = ({
  projectId,
  projectName,
  images,
  logoFallback
}) => {
  // Keine Bilder vorhanden
  if (!images || images.length === 0) {
    return (
      <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-100 aspect-video flex items-center justify-center">
        <img 
          src={getImageAssetPath(`references/logo/${logoFallback}`)} 
          alt={`${projectName} Logo`} 
          className="max-w-[60%] max-h-[60%] object-contain"
        />
      </div>
    );
  }
  
  // Nur ein Bild
  if (images.length === 1) {
    return (
      <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-100 aspect-video">
        <img 
          src={getImageAssetPath(`references/gallery/${images[0]}`)} 
          alt={`${projectName} Screenshot`} 
          className="w-full h-full object-cover"
        />
      </div>
    );
  }
  
  // Mehrere Bilder - Galerie anzeigen
  return (
    <Carousel
      className="w-full rounded-2xl overflow-hidden shadow-xl bg-gray-100 aspect-video"
      aria-label={`Galerie für ${projectName}`}
    >
      <CarouselContent>
        {images.map((image, index) => (
          <CarouselItem key={`${projectId}-image-${index}`}>
            <div className="w-full h-full aspect-video">
              <img 
                src={getImageAssetPath(`references/gallery/${image}`)} 
                alt={`${projectName} Bild ${index + 1}`} 
                className="w-full h-full object-cover"
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
};

export default Gallery; 